<template>
  <span
    class="dropdown-arrow"
    :class="{ 'dropdown-arrow--open': open }"
    aria-hidden="true"
  ></span>
</template>

<script>
export default {
  props: {
    open: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
.dropdown-arrow {
  display: inline-block;
  position: relative;
  top: 1px;
  width: 8px;
  height: 4px;
  margin: 0 0 3px 4px;
  background: url('../images/language-arrow.svg') center / 8px 4px no-repeat;
}

.dropdown-arrow--open {
  margin-bottom: 4px;
  transform: rotate(180deg);
}
</style>
